import state from './moduleProductsState'
import mutations from './moduleProductsMutations'
import actions from './moduleProductsActions'
import getters from './moduleProductsGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}

